import { render } from "./ApiKeyPairsTab.vue?vue&type=template&id=46f0b129&scoped=true"
import script from "./ApiKeyPairsTab.vue?vue&type=script&lang=js"
export * from "./ApiKeyPairsTab.vue?vue&type=script&lang=js"

import "./ApiKeyPairsTab.vue?vue&type=style&index=0&id=46f0b129&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f0b129"]])

export default __exports__